'use strict';

/* conversiontracking.js -- entry for Platinum Partner page events and campaign capture; loaded with `defer` by BasicPage.cshtml */

var campaignSnapshot = require('./components/campaignSnapshot');
var conversionTracking = require('./components/conversionTracking');

function start() {
    try {
        campaignSnapshot.capture();
        campaignSnapshot.fill();
    } catch (err) {
        // Campaign capture must never block the form.
    }
    conversionTracking.init();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
} else {
    start();
}
